import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getDeposits = () => async dispatch => {
    dispatch({
        type: actionTypes.GET_DEPOSIT_START
    });
    await axios.get('/deposits')
        .then(response => {
            dispatch({
                type: actionTypes.GET_DEPOSIT_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => dispatch({
            type: actionTypes.GET_DEPOSIT_FAIL,
            payload: getMessage(error)
        }))
}